// helpers
import { getGlobalThis } from 'shared/helpers/utils';
import { log } from 'shared/helpers/SentryLogger';
import { TAG_IDENTIFIER } from 'shared/helpers/SentryLogger/constants';

// defs
interface IDeepLinkProps {
  _appWebviewRedirect: (url: string) => string;
  _appRedirectFromUrl: (url: string, target: HTMLElement) => void;
  goTo: (e: MouseEvent, target: HTMLElement) => void;
}

const globalThis = getGlobalThis();
// @ts-ignore
const NYK_DEEPLINK: IDeepLinkProps = globalThis.NYK_DEEPLINK || {};
const MODULE_IDENTIFIER = 'DEEPLINK';

NYK_DEEPLINK._appWebviewRedirect = function _appWebviewRedirect(_url: string) {
  _url += (_url.split('?')[1] ? '&' : '?') + 'src=app';
  window.location.href = _url;
};

NYK_DEEPLINK._appRedirectFromUrl = function _appRedirectFromUrl(url: string, target: HTMLElement) {
  const categoryId = target.getAttribute('data-categoryId');
  const productId = target.getAttribute('data-productId');
  const userAgent = navigator.userAgent;

  if (userAgent.match(/nykaa-android/i)) {
    // APP_CONTEXT.ANDROID;

    if (categoryId) {
      // redirect for listing page in android
      // @ts-ignore
      window.AndroidFunction.showCategory(categoryId, '');
      return;
    }

    if (productId) {
      // redirect for product page in android
      // @ts-ignore
      window.AndroidFunction.showProduct(productId, '');
    }

    NYK_DEEPLINK._appWebviewRedirect(url);
  } else if (userAgent.match(/nykaa-ios/i)) {
    // APP_CONTEXT.IOS;

    if (categoryId) {
      // redirect for listing page in IOS
      // @ts-ignore
      window.webkit.messageHandlers.openCategoryPage.postMessage({ categoryId, title: '' });
      return;
    }

    if (productId) {
      // redirect for product page in android
      // @ts-ignore
      window.webkit.messageHandlers.showProduct.postMessage({ id: productId, title: '' });
    }

    NYK_DEEPLINK._appWebviewRedirect(url);
  } else {
    // APP_CONTEXT.WEB;
    window.location.href = url;
  }
};

NYK_DEEPLINK.goTo = function goTo(e: MouseEvent, target: HTMLElement) {
  try {
    e.preventDefault();

    NYK_DEEPLINK._appRedirectFromUrl(target.getAttribute('href') as string, target);
  } catch (err) {
    log({
      error: err,
      tags: { [TAG_IDENTIFIER.MODULE]: MODULE_IDENTIFIER },
      extraInfo: { link_url: target.getAttribute('href') },
    });
  }
};

// @ts-ignore
globalThis.NYK_DEEPLINK = NYK_DEEPLINK;
